import { Component, OnInit, Optional } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { APIService, AccountMembership, AuthorizationLevel, Team, TeamMember } from 'app/API.service.custom';
import { CreateTeamAccountComponent } from 'app/shared/account/create-team-account/create-team-account.component';
import { AddContactComponent } from 'app/shared/add-contact/add-contact.component';
import { TeamInboxComponent } from 'app/shared/conversation/team-inbox/team-inbox.component';
import { AddEmployeeBulkComponent } from 'app/shared/employee/add-employee-bulk/add-employee-bulk.component';
import { InviteToGroupNewComponent } from 'app/shared/employee/invite-to-group-new/invite-to-group-new.component';
import { CreatePropertyComponent } from 'app/shared/properties/create-property/create-property.component';
import { CreateTemplateComponent } from 'app/shared/templates/create-template/create-template.component';
import { actionDetails, actions } from 'globals/constants';
import _ from 'lodash-es';
import { DialogConfig, DialogRef, DialogService } from 'app/shared/dialog';
import { DataShareService } from 'services/data-share.service';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

@Component({
    selector: 'app-support',
    templateUrl: './support.component.html',
    styleUrls: ['./support.component.scss'],
    imports: [NgScrollbarModule, FormsModule, ReactiveFormsModule, NgxIntlTelInputModule, NgxSkeletonLoaderModule]
})
export class SupportComponent implements OnInit {

  activeAccountSubscription;
  allUserMembershipsSubscription;
  teamMembershipsSubscription;
  teamsSubscription;

  activeAccount: AccountMembership = null;
  fetchedUserMemberships: AccountMembership[] = [];

  fetchedTeamMemberships: TeamMember[] = [];
  fetchedTeams: Team[] = [];

  searchForm_activity: UntypedFormGroup;
  action = null;
  actionDetail = null;
  actionsOriginal = actions
  actionDetailsOriginal = actionDetails;
  requestSubmitted = false;
  actions = null;
  actionDetails = null;
  callingApi = false;
  searchValue = null;
  searchHasRun = false;
  showSuggestion = true;
  suggestionText = null;

  constructor(
    private router: Router,
    private dialogService: DialogService,
    @Optional() private config: DialogConfig,
    @Optional() private dialog: DialogRef,
    private dataService: DataShareService,
    private route: ActivatedRoute,
    private formBuilder: UntypedFormBuilder,
    private api: APIService,
    private sanitizer: DomSanitizer,
  ) { }

  createForm_search_activity() {
    this.searchForm_activity = this.formBuilder.group({
      'search_activity': ['', []]
    });
  }

  onEnter() {
    this.searchValue = this.searchForm_activity.get('search_activity').value;
    console.log(this.searchValue);
    this.getAction(this.searchValue);
  }

  suggestedSearch(text){
    this.searchValue = text;
    this.searchForm_activity.get('search_activity').setValue(text);
    this.searchForm_activity.get('search_activity').updateValueAndValidity(text);
    this.getAction(this.searchValue);
  }

  clearActivitySearchField(clearSearchField: boolean) {
    if (clearSearchField){
      this.searchForm_activity.get('search_activity').setValue('', { emitEvent: false });
      this.action = null;
      this.actionDetail = null;
      this.requestSubmitted = false;
      this.searchValue = null;
      this.searchHasRun = false;
    }
  }

  getAction(input ?: string){
    this.actions = _.cloneDeep(this.actionsOriginal);
    this.actionDetails = _.cloneDeep(this.actionDetailsOriginal);
    if(input && input != '' && !this.requestSubmitted){
      this.callingApi = true;
      this.requestSubmitted = true;
      this.actionDetail = null;
      this.showSuggestion = false;
      this.suggestionText = null;
      this.searchHasRun = false;
      console.log("Input before api call is ", input);
      this.api.MapDataFields(JSON.stringify(input), JSON.stringify("ADMIN_ACTION"), this.activeAccount?.accountId, this.activeAccount?.userId).then(async event => {
        this.requestSubmitted = false;
        this.callingApi = false;
        this.searchHasRun = true;
        console.log("event received from gpt ", event);
        if (event) {
          event = JSON.parse(event);
          if (event["statusCode"] == 200 && event["body"]) {
            let actionIdentified = (event["body"]).toLowerCase();
            if((event["body"]).toLowerCase() == "none"){
              this.action = null;
              this.actionDetail = null;
              this.requestSubmitted = false;
            }
            else if((event["body"]).toLowerCase().startsWith("did you mean") || (event["body"]).toLowerCase().startsWith("possible action")){
              let rcvdText = (event["body"]).toLowerCase();
              rcvdText = rcvdText.replace("did you mean", "");
              rcvdText = rcvdText.replace("possible action", "");
              rcvdText = rcvdText.replace(":", "");
              rcvdText = rcvdText.replace("?", "");
              this.showSuggestion = true;
              this.suggestionText = rcvdText;
              this.action = null;
              this.actionDetail = null;
              this.requestSubmitted = false;
            }
            else{
              let matchIndex = this.actions.findIndex(item => item.label == actionIdentified);
              if(matchIndex != null && matchIndex != -1){
                this.action = this.actions[matchIndex].value;
                this.actionDetail = this.actionDetails[this.action];
                if(this.actionDetail && this.actionDetail.length > 0){
                  for(let _i = 0; _i < this.actionDetail.length; _i++){
                    if(this.actionDetail[_i].webVideoLink){
                      this.actionDetail[_i].webVideoLink = this.sanitizer.bypassSecurityTrustResourceUrl(this.actionDetail[_i].webVideoLink);
                    }
                    if(this.actionDetail[_i].appVideoLink){
                      this.actionDetail[_i].appVideoLink = this.sanitizer.bypassSecurityTrustResourceUrl(this.actionDetail[_i].appVideoLink);
                    }
                  }
                }
                console.log("action detail is ", this.actionDetail);
              }
            }
          }
        }
      })
      .catch(e => {
        this.callingApi = false;
        this.searchHasRun = true;
        this.requestSubmitted = false;
        console.log("In search error: ", e);
      });
    }
  }

  takeAction(actionName : string){
    switch(actionName){
      case 'upload_lead' : {
        this.bulkUpload();
        break;
      }
      case 'add_single_lead' : {
        this.addSingleLead();
        break;
      }
      case 'create_workspace' : {
        this.createOrganzationButtonClicked();
        break;
      }
      case 'invite_user' : {
        this.inviteNewUser();
        break;
      }
      case 'remove_user' : {
        this.goToUsers();
        break;
      }
      case 'create_team' : {
        this.createTeam();
        break;
      }
      case 'view_team' : {
        this.goToTeams();
        break;
      }
      case 'export_data' : {
        this.goToActiveLeads();
        break;
      }
      case 'view_export' : {
        this.goToExports();
        break;
      }
      case 'create_template' : {
        this.createTemplate();
        break;
      }
      case 'view_template' : {
        this.goToTemplates();
        break;
      }
      case 'create_form' : {
        this.createForm();
        break;
      }
      case 'link_form' : {
        this.goToForms();
        break;
      }
      case 'view_metrics' : {
        this.dialog.close();
        this.router.navigate(['/metrics/performance']);
        break;
      }
      case 'view_source_reports' : {
        this.dialog.close();
        this.router.navigate(['/metrics/source-report']);
        break;
      }
      case 'view_attendance' : {
        this.dialog.close();
        this.router.navigate(['/metrics/attendance']);
        break;
      }
      case 'view_call_recordings' : {
        this.dialog.close();
        this.router.navigate(['/engagements/calls']);
        break;
      }
      case 'view_call_recordings' : {
        this.dialog.close();
        this.router.navigate(['/engagements/calls']);
        break;
      }
      case 'create_distribution' : {
        this.newLeadDistributionSetup();
        break;
      }
      case 'create_distribution_dynamic' : {
        this.newLeadDistributionSetup();
        break;
      }
      case 'edit_user' : {
        this.dialog.close();
        this.router.navigate(['/account/profile', { outlets: { 'profile': ['profile-detail'] } }]);
        break;
      }
      case 'integrations' : {
        this.goToIntegrations();
        break;
      }
      case 'create_property' : {
        this.createProperty();
        break;
      }
    }
  }
  ngOnInit(): void {
    this.createForm_search_activity();

    this.searchForm_activity.get('search_activity').valueChanges.subscribe((searchValue) => {
      this.searchHasRun = false;
    });

    this.activeAccountSubscription = this.dataService.getActiveAccount().subscribe((param: any) => {
      if (param) {
        this.activeAccount = param;
        console.log("in support component, activeAccount is ", this.activeAccount);
        let authLevel = this.activeAccount.authorizationLevel;
        this.allUserMembershipsSubscription = this.dataService.getAllIncludingInactiveUsersInAccount().subscribe((param2: any) => {
          if (param2) {
            this.fetchedUserMemberships = param2;
            console.log('All Users Fetched for the account : ', param2);
          }
        });
        if (authLevel == AuthorizationLevel.ADMIN || authLevel == AuthorizationLevel.SUPERADMIN) {
          this.teamMembershipsSubscription = this.dataService.getTeamMemberships().subscribe((param3: any) => {
            if (param3) {
              this.fetchedTeamMemberships = param3;
              console.log('Team Memberships Fetched : ', param3);
            }
          });
          this.teamsSubscription = this.dataService.getTeams().subscribe((param4: any) => {
            if (param4) {
              this.fetchedTeams = param4;
              console.log('Teams Fetched : ', param4);
            }
          });
        }
        else if (authLevel == AuthorizationLevel.MANAGER) {
          this.teamMembershipsSubscription = this.dataService.getDirectReportees().subscribe((param4: any) => {
            if (param4) {
              this.fetchedTeamMemberships = param4;
              console.log('Team Memberships Fetched : ', param4);
            }
          });
          this.teamsSubscription = this.dataService.getDirectTeamsAsTL().subscribe((param4: any) => {
            if (param4) {
              console.log('as Manager teams Fetched : ', param4);
              this.fetchedTeams = param4.map((item) => item.team);;
              console.log('Teams Fetched : ', param4);
            }
          });
        }
      }
    });
  }

  ngOnDestroy(): void {
    if (this.activeAccountSubscription && !this.activeAccountSubscription.closed)
      this.activeAccountSubscription.unsubscribe();
    if (this.teamMembershipsSubscription && !this.teamMembershipsSubscription.closed)
      this.teamMembershipsSubscription.unsubscribe();
    if (this.teamsSubscription && !this.teamsSubscription.closed)
      this.teamsSubscription.unsubscribe();
    if (this.allUserMembershipsSubscription && !this.allUserMembershipsSubscription.closed)
      this.allUserMembershipsSubscription.unsubscribe();
  }

  bulkUpload() {
    this.dialog?.close();
    this.router.navigate(['/leads/bulk-add-new']);
  }

  addSingleLead() {
    this.dialog?.close();
    this.dialogService.open(AddContactComponent, {}, 0 , false);
  }

  viewExports() {
    this.dialog?.close();
    this.router.navigate(['/export/exports']);
  }

  newLeadDistributionSetup() {
    this.dialog?.close();
    this.router.navigate(['/leads/define-distribution']);
  }

  inviteNewUser() {
    this.dialog?.close();
    this.dialogService.open(AddEmployeeBulkComponent, {
      data: { accountMembership: this.activeAccount }
    }, 1);
  }

  getStarted() {
    this.dialog?.close();
    this.router.navigate(['/home/get-started']);
  }

  goToIntegrations() {
    this.dialog?.close();
    this.router.navigate(['/admin/integrations', { outlets: { 'integration': ['all-apps'] } }]);
  }

  goToUsers() {
    this.dialog?.close();
    this.router.navigate(['/admin/users']);
  }

  goToTeams() {
    this.dialog?.close();
    this.router.navigate(['/admin/users'], { queryParams: { tab: 'teams' } });
  }

  goToActiveLeads() {
    this.dialog?.close();
    this.router.navigate(['/leads/all-leads']);
  }

  goToExports() {
    this.dialog?.close();
    this.router.navigate(['/export/exports']);
  }

  goToCustomization() {
    this.dialog?.close();
    this.router.navigate(['/admin/settings', { outlets: { 'settings': ['customizations'] } }]);
  }

  goToForms() {
    this.dialog?.close();
    this.router.navigate(['/admin/forms']);
  }

  createProperty() {
    this.dialog?.close();
    this.dialogService.open(CreatePropertyComponent, {

    }, 1);
  }

  createTeam() {
    this.dialog?.close();
    this.dialogService.open(InviteToGroupNewComponent, {
      data: { allUsers: this.fetchedUserMemberships, allTeamMemberships: this.fetchedTeamMemberships, activeAccount: this.activeAccount }
    }, 1);
  }

  createForm() {
    this.dialog?.close();
    this.router.navigate(['/admin/create-form']);
  }

  goToTemplates() {
    this.dialog?.close();
    this.router.navigate(['/admin/templates']);
  }

  goToAccount() {
    this.dialog?.close();
    this.router.navigate(['/admin/settings', { outlets: { 'settings': ['basic-detail'] } }]);
  }

  manageAccess() {
    this.dialog?.close();
    this.router.navigate(['/admin/settings', { outlets: { 'settings': ['role-access'] } }]);
  }
  
  removeDoNotTrack() {
    this.dialog?.close();
    this.router.navigate(['/admin/settings', { outlets: { 'settings': ['do-not-track'] } }]);
  }

  updateAccount() {
    this.dialog?.close('update-account');
  }

  updateAccountDefault() {
    this.dialog?.close('update-account-default');
  }

  createTemplate() {
    this.dialog?.close();
    this.dialogService.open(CreateTemplateComponent, {

    }, 1);
  }

  createOrganzationButtonClicked(): void {
    this.dialog?.close();
    
    this.dialogService.open(CreateTeamAccountComponent, {
    });
  }

  connectFacebook() {
    this.dialog?.close("facebook");

  }

  connectIndiamart() {

  }

  openWhatsapp(){
    window.open("https://wa.me/919902127389", '_blank');
  }

  openSupportChat(){
    let channeId = `${this.activeAccount.accountId}__SALESMAX_SUPPORT_ALL`;
    let ref = this.dialogService.open(TeamInboxComponent, {
      data: { selectedChannelId: channeId, viewMode: 'dialog-mode' }
    }, 1);
  }

}
